import {
  Anchor,
  Button,
  Checkbox,
  Group,
  List,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import { IconCheck, IconSend } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { pluralize } from "./review.utils";

export const ReadyForLabPanel = ({
  patientName,
  productsCount,
  deliveryText,
  showDesignRequest,
  isDesignRequested,
  onDesignRequestedToggle,
  onSend,
  isSending,
}: {
  patientName: string;
  productsCount: number;
  deliveryText?: string;
  showDesignRequest: boolean;
  isDesignRequested: boolean;
  onDesignRequestedToggle: () => void;
  onSend: () => void;
  isSending: boolean;
}) => {
  return (
    <Stack gap="lg">
      <Stack gap="sm">
        <Title variant="display" size="md" c="brand.9">
          Prêt pour le{" "}
          <Text span inherit variant="accent">
            laboratoire
          </Text>
          .
        </Title>
        <Text size="sm">Prise en charge sous 2 h après l&#39;envoi.</Text>
      </Stack>

      <List
        size="sm"
        center
        icon={
          <ThemeIcon variant="transparent" color="success" size="sm">
            <IconCheck />
          </ThemeIcon>
        }
      >
        <List.Item>Patient · {patientName}</List.Item>
        <List.Item>
          {pluralize(
            productsCount,
            "prothèse configurée",
            "prothèses configurées"
          )}
        </List.Item>
        {deliveryText && <List.Item>Livraison · {deliveryText}</List.Item>}
      </List>

      {/* Optional design preview before manufacturing, behind the "order_design_request" feature flag as in V1 */}
      {showDesignRequest && (
        <Checkbox.Card
          checked={isDesignRequested}
          onClick={onDesignRequestedToggle}
          radius="lg"
          p="md"
        >
          <Group gap="sm" wrap="nowrap">
            <Checkbox.Indicator />
            <Text variant="strong">Demander un aperçu du design</Text>
          </Group>
        </Checkbox.Card>
      )}

      <Stack gap="sm">
        <Button
          size="lg"
          fz="md"
          fullWidth
          leftSection={<IconSend size={16} />}
          onClick={onSend}
          loading={isSending}
        >
          Envoyer au laboratoire
        </Button>
        <Text variant="caption" ta="center">
          En envoyant, vous attestez l&#39;exactitude des informations cliniques
          et acceptez les{" "}
          <Anchor
            component={Link}
            to="/cgv"
            target="_blank"
            inherit
            underline="always"
          >
            CGV de Jasper
          </Anchor>
          .
        </Text>
      </Stack>
    </Stack>
  );
};
